import React, { useState } from "react";
import { getAPI, postAPI } from "../../../helpers/httpHelper";
import { cognitoUserToken } from "../../../helpers/userHelper";
import { URL_SUPPORT, ROW_COUNT, API_ADMIN_PARAMETROS } from "../../../helpers/variableHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import AdminLista from "../AdminLista";

const Parametros = () => {
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<any>>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);

    let params = { PAGINA: 1, PAGINADO: pageSize, ORDENADOPOR: "ID", ORIENTACION: "DESC" };
    let result = (await getAPI(`${URL_SUPPORT}${API_ADMIN_PARAMETROS}/getall`, { Authorization: `Bearer ${token}` }, params)).result;
    let list = result.data;
    setListItems(list);
    let pages = result.pages;
    setPages(pages);
    setIsLoading(false);
  }, [token]);
  const paging = (page: any) => {
    setPage(page);
    let params = { PAGINA: page };
    filter(params, true);
  };
  const filter = (filter: any, havePage: boolean = false, size = pageSize) => {
    if (!filter) {
      filter = {};
      filter.PAGINA = 1;
    }
    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    if (!havePage && filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    setPage(filter.PAGINA);
    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }
    getAPI(`${URL_SUPPORT}${API_ADMIN_PARAMETROS}/getall`, { Authorization: `Bearer ${token}` }, filter)
      .then((result) => {
        setIsLoading(false);
        setListItems(result.result.data);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {});
  };
  const edit = (value: any, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    if (value.ID === "") {
      delete value.ID;
    }

    postAPI(`${URL_SUPPORT}${API_ADMIN_PARAMETROS}`, value, { Authorization: `Bearer ${token}` })
      .then((result) => {
        let data = result.result.data;
        console.log(data);
        filter(filters, value?.ID > 0);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <button
        data-testid="btnedit"
        hidden={true}
        onClick={() => {
          edit(
            {
              ID: "",
              ACTIVO: true,
              ID_ACTO: "1",
              ID_TIPO_CAUSA: 1,
              ORDENADOPOR: "",
              ORIENTACION: "",
              PAGINA: 1,
              PAGINADO: 10,
              TIPO_CAUSA: "",
              TITULO: "",
            },
            {}
          );
          paging(1);
          filter(false, false, 1);
        }}></button>
      <AdminLista
        reload={filter}
        callback={edit}
        data={listItems}
        tipo={"Parametros"}
        filter={filter}
        pagination={{ pages: pages, page: page, paging: paging }}
        title="Parámetros"
        callbackUpdatePageSize={(pageSize: number, filters: Object) => {
          setPageSize(pageSize);
          filter(filters, false, pageSize);
        }}
        isLoading={isLoading}
      />
    </>
  );
};

export default Parametros;
